// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Tag, { TagPresentationProps } from "@insite/mobius/Tag";
import getColor from "@insite/mobius/utilities/getColor";
import TagWrapper, { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import React from "react";
import { css } from "styled-components";

interface Props {
    categoriesList?: string[];
    isArchived?: boolean;
    extendedStyles?: BlogCategoriesStyles;
}

export interface BlogCategoriesStyles {
    tagWrapper?: TagWrapperProps;
    tagArchived?: TagPresentationProps;
}

export const blogCategoriesStyles: BlogCategoriesStyles = {
    tagWrapper: {},
    tagArchived: {
        css: css`
            background-color: ${getColor("accent")};
            color: ${getColor("white")};
        `,
        mergeCss: true,
    },
};

const BlogCategories = ({ categoriesList, isArchived, extendedStyles }: Props) => {
    if (!isArchived && (categoriesList === undefined || !categoriesList.length)) {
        return <div></div>;
    }

    const styles = useMergeProps(blogCategoriesStyles, extendedStyles);
    const archivedLabel = translate("Archived");

    return (
        <TagWrapper {...styles.tagWrapper}>
            {isArchived && (
                <Tag deletable={false} key={archivedLabel} {...styles.tagArchived}>
                    {archivedLabel}
                </Tag>
            )}
            {categoriesList?.map(item => (
                <Tag deletable={false} key={item}>
                    {item}
                </Tag>
            ))}
        </TagWrapper>
    );
};

export default BlogCategories;
